import { useEffect, useState } from 'react'
import { chunk, flatten, isNil, zip } from 'lodash'
import useAbortController from 'utils/customHook/useAbortController'
import useBoolean from 'utils/customHook/useBoolean'
import CatchmentAction from 'catchment/actions/CatchmentAction'
import DtoSumAnalysisLight from 'catchment/dto/DtoSumAnalysisLight'
import { callPromisesSequentially } from 'utils/ActionUtils'

const useFetchSumAnalysis = (filters) => {
    const {
        controllerRef,
        initController,
    } = useAbortController()

    const {
        value: isLoaded,
        setFalse: setNotLoaded,
        setTrue: setLoaded,
    } = useBoolean(false)
    const [progress, setProgress] = useState(0)

    const [sumAnalysis, setSumAnalysis] = useState([])

    useEffect(() => {
        if (filters.stations.length === 0 || isNil(filters.startDate) || isNil(filters.endDate) || filters.parameters.length === 0) return

        setNotLoaded()
        setProgress(0)
        initController()
        setSumAnalysis([])

        const [promises, params] = (() => {
            const { stations, ...searchFilter } = filters
            const groupSize = Math.min(Math.floor(stations.length / 10), 10) || 1
            return zip(...chunk(filters.stations, groupSize).map(s => [CatchmentAction.getSumAnalysis, [{ ...searchFilter, stations: s }, controllerRef.current.signal]]))
        })()
        callPromisesSequentially(
            promises,
            params,
            pr => {
                setProgress(pr)
            },
            json => {
                setSumAnalysis(flatten(json).map(a => new DtoSumAnalysisLight(a)))
                if (!controllerRef.current.signal.aborted) {
                    setLoaded()
                }
            },
        )

        // eslint-disable-next-line consistent-return
        return () => {
            controllerRef.current.abort()
        }
    }, [filters])

    return {
        sumAnalysis,
        isLoaded,
        progress,
    }
}

export default useFetchSumAnalysis